import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AiToReviewInspectionsIndex from './AiToReviewInspectionsIndex.tsx';

const queryClient = new QueryClient();

export default function AiToReviewInspections(props) {
  return (
    <QueryClientProvider client={queryClient}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <AiToReviewInspectionsIndex {...props} />
    </QueryClientProvider>
  );
}
